import { createSignal } from './signal.js';
export function createComputed(dependencies, fn, 
// only used to prevent excessive updating
debounceTimeout = 8) {
    let updateTimeout = null;
    const computed = createSignal(fn(dependencies));
    const debouncedUpdate = () => {
        computed.update(fn(dependencies));
    };
    const dependencyChangedHandler = () => {
        if (updateTimeout) {
            clearTimeout(updateTimeout);
            updateTimeout = null;
        }
        updateTimeout = setTimeout(debouncedUpdate, debounceTimeout);
    };
    const listen = () => {
        dependencies.forEach((dep) => {
            dep.emitter.on('change', dependencyChangedHandler);
        });
    };
    const unlisten = () => {
        dependencies.forEach((dep) => {
            dep.emitter.off('change', dependencyChangedHandler);
        });
    };
    listen();
    return {
        ...computed,
        listen,
        unlisten,
    };
}
